"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallParagraph = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../helpers");
const Text_1 = require("../Text");
const View_1 = require("../View");
const StructureText_1 = require("./StructureText");
exports.SmallParagraph = (0, helpers_1.createUIElement)('SmallParagraph', (_a, ref) => {
    var { className, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StructureText_1.StructureText, Object.assign({}, rest, { testId: rest['data-selector-id'] || 'small-paragraph', className: `vm-SmallParagraph ${className}`, asTag: 'p', view: Text_1.TEXT_VIEW.primary, size: Text_1.TEXT_SIZE.s, weight: Text_1.TEXT_WEIGHT.normal, trailer: View_1.INDENT.xs, "data-typo": true, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
//# sourceMappingURL=SmallParagraph.js.map